@if (status) {
  @if (size === 'small') {
    <mat-icon
      class="filled-in-mat-icon"
      [class.featured]="featured"
      style="padding: 4px; box-sizing: content-box"
      [ngClass]="(status | shortageStatusAvailability) ? 'primary' : 'warn'"
      [color]="(status | shortageStatusAvailability) ? 'primary' : 'warn'"
    >
      {{ shortageStatusIconMap.get(status) }}
    </mat-icon>
  }

  @if (size === 'big') {
    <button
      mat-icon-button
      class="filled-in-icon-button"
      style="cursor: default"
      [ngClass]="(status | shortageStatusAvailability) ? 'primary' : 'warn'"
      [color]="(status | shortageStatusAvailability) ? 'primary' : 'warn'"
    >
      <mat-icon [class.featured]="featured">
        {{ shortageStatusIconMap.get(status) }}
      </mat-icon>
    </button>
  }
}
